import { useMemo } from 'react';
import { useCurrentEnterprise } from '@mews-commander/legacy-entities/src/enterprise';
import { Stack } from '@optimus-web/core';
import { ModalWrapper, NewModalBodyWrapper } from '@mews-commander/ui';
import { TextKey, RouteName } from '@mews-commander/enums';
import { useResolveRoute } from '@mews/routing';
import { lt } from '@mews/framework';
import { RoutingRuleForm } from '../components/form';
import { RoutingRuleFormStepContextProvider } from '../contexts';
import BreadcrumbList, { Breadcrumbs } from '../../../components/BreadcrumbList';
import { useRoutingRulesData } from '../queries';

export const RoutingRulesStepsView = ({ routingRuleId }: { routingRuleId?: string }) => {
    const { data: routingRuleSingleResult } = useRoutingRulesData(routingRuleId);
    const routingRuleName = routingRuleSingleResult?.routingRules?.[0]?.name;
    const breadcrumbs = useBreadcrumbs(routingRuleName, routingRuleId);

    return (
        <ModalWrapper>
            <NewModalBodyWrapper padded>
                <Stack vertical spacing="300">
                    <BreadcrumbList breadcrumbs={breadcrumbs} alignment="start" />
                    <RoutingRuleFormStepContextProvider>
                        <RoutingRuleForm routingRuleId={routingRuleId} />
                    </RoutingRuleFormStepContextProvider>
                </Stack>
            </NewModalBodyWrapper>
        </ModalWrapper>
    );
};

const useBreadcrumbs = (routingRuleName?: string | null, routingRuleId?: string): Breadcrumbs => {
    const resolveRoute = useResolveRoute();
    const { id, name } = useCurrentEnterprise();

    return useMemo(
        () => [
            {
                text: name,
                url: resolveRoute(RouteName.EnterpriseDetail, { enterpriseId: id }),
            },
            {
                text: lt(TextKey.BillingAutomationPlural),
                url: resolveRoute(RouteName.RoutingRuleIndex),
            },
            {
                active: true,
                text: routingRuleId ? routingRuleName : lt(TextKey.NewBillingAutomation),
            },
        ],
        [name, resolveRoute, id, routingRuleId, routingRuleName]
    );
};
